import { useQueryGetAllUiPreferences } from "@apis:ui_preferences/ui_preferences";
import { useUser } from "@libs:react-query-auth";
import { useMemo } from "react";

type UserPreference = {
  showMessageTokenUsage?: boolean | null;
};

export const useCheckMessageTokenUsage = () => {
  const user = useUser().data;
  const userId = user?.id;

  const { data: uiPreferences, isLoading } = useQueryGetAllUiPreferences(
    true,
    userId,
    undefined,
    {
      enabled: !!userId,
    },
  );

  const isTokenUsageVisible = useMemo(() => {
    if (!uiPreferences || !userId) return false;

    const userPreference = uiPreferences.find(
      (pref) => pref.userId === userId && !pref.botId,
    );
    const showTokenUsage = (userPreference?.preference as UserPreference)
      ?.showMessageTokenUsage;

    return showTokenUsage === true;
  }, [uiPreferences, userId]);

  return {
    isTokenUsageVisible,
    isLoading,
  };
};
